/*

*/

export const Demo = {
  primaryPage: {
    deviceType: 'New Device',
    chart: false,
    settingTypes: [],
    telemetryTypes: [
      'inOne',
      'inTwo',
      // 'inThree',
      // 'vinMonitor',
      'oneWire',
      'variableReluctance',
      'chargeLevel',
      'inputPower',
      'outOne',
      'outTwo',
      'outThree',
      'outFour',
      'cellularSignal',
      'sleep',
      'boardVersion',
    ],
    physicalTypes: [],
    rules: false,
  },
  advancedPage: {
    settingTypes: [
      'sleepInterval',
      'update',
    ],
    telemetryTypes: [],
    physicalTypes: [
      'deviceType',
      'deviceNumber',
    ],
    rules: true,
  },
}

export const Default = Demo
